import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Dialog, IconButton, Tooltip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import { openEdicionCalleCamionCaladoDialog, updateCalleCamionCalado } from '../../actions'
import DialogoEdicionCalleCamionView from './DialogoEdicionCalleCamionView'
import { FORM_PROCESO_CALADO } from '../../../../config/forms'
import { reduxForm, formValueSelector } from 'redux-form'

function MoverCamionDeCalle (props) {
  const { cea } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth='xs'
      >
        <DialogoEdicionCalleCamionView cea={cea} handleClose={handleClose} />
      </Dialog>
      <div style={{ float: 'right' }}>
        <Tooltip title={'Editar calle'}>
          <IconButton onClick={handleOpen}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      </div>
    </>
  )
}

const selector = formValueSelector(FORM_PROCESO_CALADO)
const mapStateToProps = state => {
  return {
    calle: selector(state, 'calle'),
    estadoCalles: state.calado.estadoOcupacionCallesCalado
  }
}

const mapActionsToProps = {
  openEdicionCalleCamionCaladoDialog,
  updateCalleCamionCalado
}

export default reduxForm({
  form: FORM_PROCESO_CALADO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})(connect(mapStateToProps, mapActionsToProps)(MoverCamionDeCalle))
